export default __webpack_public_path__ + "static/media/Escudo-horizontal_baja.001b5842.png";